import React from "react";
import { IoArrowBack, IoCalendarOutline } from "react-icons/io5";
import { FaRupeeSign } from "react-icons/fa";
import dummyimage from "../../img/default_avatar.jpg";

const OldMinimalProfileBlock = ({
  state,
  isHovered,
  setIsHovered,
  setState,
  setShowServiceDropdown,
  setScrollPosition,
  setCurrentIndex,
  API_URL,
  onBack,
}) => {
  return (
    <section className="box-rd p-0 profileBlock">
      <div className="profileCont">
        <button
          onClick={onBack}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            background: "none",
            border: "none",
            padding: "8px",
            cursor: "pointer",
            color: "#4a5568",
            transition: "all 0.2s ease",
            transform: isHovered ? "translateX(-4px)" : "none",
            opacity: isHovered ? 0.8 : 1,
          }}
        >
          <IoArrowBack style={{ fontSize: "1.5rem" }} />
          <span style={{ fontWeight: "500", fontSize: "1.2rem" }}>
            Service Booking
          </span>
        </button>

        <section
          className="serviceDetailsSec"
          style={{ backgroundColor: "#f8f9fa" }}
        >
          <h6
            style={{
              margin: "0 0 0.5rem",
              color: "#2d3748",
              fontSize: "clamp(14px, 2vw, 16px)",
              fontWeight: "600",
            }}
          >
            {state.serviceDetails.serviceName}
          </h6>

          {state.serviceDetails.description && (
            <p
              style={{
                color: "#718096",
                fontSize: "clamp(13px, 1.8vw, 15px)",
                margin: "0",
                lineHeight: "1.5",
              }}
            >
              {state.serviceDetails.description}
            </p>
          )}

          <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
            <span
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
                color: "#4a5568",
                fontSize: "clamp(10px, 2vw, 16px)",
              }}
            >
              <IoCalendarOutline />
              {state.minutes} mins meeting
            </span>
          </div>

          <div>
            <span
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.2rem",
                color: "#4a5568",
                fontSize: "clamp(14px, 2vw, 16px)",
              }}
            >
              <FaRupeeSign style={{ minWidth: "20px" }} />
              {state.serviceAmount}
            </span>
          </div>
        </section>
      </div>

      <div className="profileDetailsCard">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            paddingTop: "0.5rem",
            paddingBottom: "0.5rem",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "8rem",
                height: "8rem",
                borderRadius: "50%",
                border: "3px solid #eaeaea",
                padding: "4px",
                background: "#ffffff",
              }}
            >
              <img
                src={`${API_URL}api/getUserPhoto/${state.userDetails.userId}/name`}
                alt="user"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = dummyimage;
                }}
                style={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            </div>
            <h4
              style={{
                color: "#2d3748",
                margin: 0,
                fontWeight: "600",
                fontSize: "1.5rem",
                textTransform: "capitalize",
              }}
            >
              {state.userDetails.userName}
            </h4>
          </div>

          <div className="providerCont">
            <section style={{ padding: "0.5rem", textAlign: "center" }}>
              <h6
                style={{
                  margin: "0 0 0.5rem",
                  color: "#2d3748",
                  fontSize: "clamp(14px, 2vw, 16px)",
                  fontWeight: "600",
                }}
              >
                TimeZone
              </h6>
              <span
                style={{
                  color: "#718096",
                  fontSize: "clamp(13px, 1.8vw, 15px)",
                }}
              >
                {state.eventDetails.timeZone}
              </span>
            </section>

            <section style={{ padding: "0.5rem", textAlign: "center" }}>
              <h6
                style={{
                  margin: "0 0 0.8rem",
                  color: "#2d3748",
                  fontSize: "clamp(14px, 2vw, 16px)",
                  fontWeight: "600",
                }}
              >
                Languages
              </h6>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "0.5rem",
                  justifyContent: "center",
                }}
              >
                {state.language.map((item, i) => (
                  <span
                    key={i}
                    style={{
                      color: "#718096",
                      fontSize: "clamp(13px, 1.8vw, 15px)",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {item.language}
                    {i < state.language.length - 1 && ","}
                  </span>
                ))}
              </div>
            </section>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OldMinimalProfileBlock;